import React from 'react';
import { MailIcon, SettingsIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-slate-900 text-slate-300 py-10 px-4" data-id="element-119">
      <div className="max-w-4xl mx-auto text-center" data-id="element-120">
        <div className="inline-flex items-center gap-2 text-sm font-bold text-white mb-3" data-id="element-121">
          <SettingsIcon className="w-5 h-5 text-green-400" data-id="element-122" />
          <span data-id="element-123">Soporte</span>
        </div>
        <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-green-300 hover:text-green-200 font-medium" data-id="element-124">
          <MailIcon className="w-4 h-4" data-id="element-125" />
          EbookDreamShop@gmail.com
        </a>

        <div className="mt-6 pt-6 border-t border-slate-700 text-xs text-slate-500" data-id="element-126">
          <p data-id="element-127">
            © {new Date().getFullYear()} Carrera Veterinaria 360 —
            EbookDreamShop. Todos los derechos reservados.
          </p>
          <p className="mt-2 max-w-2xl mx-auto" data-id="element-128">
            Este sitio no forma parte del sitio web de Facebook ni de Facebook
            Inc. Este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </div>
    </footer>;
}